import { useEffect, useState } from "react";
import { ethers } from "ethers";
import contract from "./utils/contract.json";
import Header from "./components/Header";
import Banner from "./components/Banner";
import Carrousel from "./components/Carrousel";
import ConfigNft from "./components/ConfigNft";
import Exclusives from "./components/Exclisives";
import Museum from "./components/Museum";
import Accordion from "./components/Accordion";
import Footer from "./components/Footer.js";
import Loading from "./components/Loading";
import axios from "axios";
import Team from "./components/Team";
import MintSection from "./components/MintSection";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useTranslation } from "react-i18next";
import ReactGA from "react-ga";
import TransakComponet from "./components/transak";
import { Colabs } from "./components/Colabs";
const MySwal = withReactContent(Swal);

ReactGA.initialize("UA-219542379-1");

function App() {

  const [wallet, setWallet] = useState(null);
  const [chain, setChain] = useState("");
  const [tokensMinted, setTokensMinted] = useState([]);
  const [isPending, setIspending] = useState(false);
  const [minted, setMinted] = useState(false);

  const [price, setPrice] = useState(50);
  const [userw, setUserw] = useState(false);
  const [whitelistOn, setWhitelistOn] = useState(false);

  const [minting, setIsMinting] = useState(false);
  const [txn, setTxn] = useState(null);
  const [currentSupply, setCurrentSupply] = useState(0);
  const [nfts, setNfts] = useState([]);
  const [showNftComponent, setShowNftComponent] = useState(false);
  const [ t, i18n ] = useTranslation(['home']);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "0xeF453154766505FEB9dBF0a58E6990fd6eB66969",

    SCAN_LINK: "https://polygonscan.com/",

    NETWORK: {
      NAME: "Polygon",
      SYMBOL: "Matic",
      ID: "0x89",
    },
    MAX_SUPPLY: 1302,
    DISPLAY_COST: 0,
    GAS_LIMIT: 985000,
    MARKETPLACE: "opensea",
    MARKETPLACE_LINK: `https://opensea.io/collection/mrcrypto-by-racksmafia/`,
  });

  const getUserWallet = async (e) => {
    const ethereum = window.ethereum;
    if (ethereum) {
      try {
        const eth = await ethereum.request({ method: "eth_requestAccounts" });

        let chainId = await ethereum.request({ method: "eth_chainId" });
        console.log("connected to chain" + chainId);
        setChain(chainId);
        setWallet(eth);

        if (chainId != CONFIG.NETWORK.ID) return addPolygonNetwork();
      } catch (error) {
        setWallet(null);
      }
    } else {
      MySwal.fire({
        icon: "warning",
        title: <p>{t('YouDonHaveMetamask')}</p>,
        text: t('YouDonHhaveMetamaskDescription'),
        confirmButtonColor: "#ecc06f",
        confirmButtonText: t('Accept'),
        footer:
          '<a tex style="color: #6a4f1e; text-decoration: none;" href="https://metamask.io/" target="_blank">¿Cómo lo descargo y lo instalo?</a>',
      });
      // alert("No tienes metamask, instala metamask para poder mintear ");
    }
  };

  const CheckWalletConnection = () => {
    const { ethereum } = window;

    if (!ethereum) {
      console.log("Make sure you have metamask");
      return;
    }

    setWallet(ethereum.selectedAddress);
  };

  const userIswhitelisted = async () => {
    //require not paused
    // if whitelist on == true -> require whitelist

    try {
      const { ethereum } = window;

      const provider = new ethers.providers.Web3Provider(ethereum);
      const signer = provider.getSigner();
      const connectedContract = new ethers.Contract(
        CONFIG.CONTRACT_ADDRESS,
        contract.output.abi,
        signer
      );
      const [address] = await provider.listAccounts();
      const whitelistOn = await connectedContract.whitelistOn();
      if (whitelistOn) {
        let isWhitelsitedTXN = await connectedContract.isWhitelisted(address);
        setWhitelistOn(true);
        console.log("User is whitelsited ", isWhitelsitedTXN);
        setUserw(isWhitelsitedTXN);
      } else {
        setUserw(false);
      }
    } catch (error) {
      console.log("iswhitelisteERR", error);
    }
  };

  async function addPolygonNetwork() {
    const { ethereum } = window;

    try {
      //si el usuario ya tiene matic añadida, se cambia a esa red(en este caso es la testnet de matic)
      await ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x89" }], // Hexadecimal version of 80001, prefixed with 0x
      });
    } catch (error) {
      console.log(error);
      // si no tiene matic añadimos pedimos permiso para que añada
      if (error.code === 4902) {
        try {
          await ethereum.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainId: "0x89", // Hexadecimal version of 80001, prefixed with 0x
                chainName: "Polygon",
                nativeCurrency: {
                  name: "MATIC",
                  symbol: "MATIC",
                  decimals: 18,
                },
                rpcUrls: ["https://polygon-rpc.com"],
                blockExplorerUrls: ["https://polygonscan.com/"],
                iconUrls: [
                  "https://cryptologos.cc/logos/polygon-matic-logo.png",
                ],
              },
            ],
          });
        } catch (addError) {
          console.log("Did not add network");
        }
      }
    }
  }

  const MintNFT = async (num) => {
    //require not paused
    // if whitelist on == true -> require whitelist

    try {
      !wallet && (await getUserWallet());
      await getCurrentSupply();

      const mintPrice = num * price;

      const { ethereum } = window;
      let chainId = await ethereum.request({ method: "eth_chainId" });
      setChain(chainId);

      if (chainId != CONFIG.NETWORK.ID) return addPolygonNetwork();

      if (ethereum) {
        const provider = new ethers.providers.Web3Provider(ethereum);
        const signer = provider.getSigner();
        const connectedContract = new ethers.Contract(
          CONFIG.CONTRACT_ADDRESS,
          contract.output.abi,
          signer
        );

        let nftTxn = await connectedContract.mint(num, {
          value: ethers.utils.parseEther(mintPrice.toString()),
        });
        setIsMinting(true);
        console.log("Mining...please wait.");
        await nftTxn.wait();
        setIsMinting(false);
        getCurrentSupply();
        setMinted(true);

        setTxn(`https://polygonscan.com/tx/${nftTxn.hash}`);

        const receipt = await provider.getTransactionReceipt(nftTxn.hash);
        const isRevealed = await connectedContract.revealed();
        const tokensmintedintxn = await decodeTxnLogs(receipt);
        await getnft(tokensmintedintxn, isRevealed);
      } else {
      }
    } catch (error) {
      MySwal.fire({
        icon: error.code == "-32603" ? "warning" : "error",
        title:
          error.code == 4001
            ? t('TransactionCanceled')
            : error.code == "-32603"
            ? t('YouCanLieRightNow')
            : t('WeHaveProblem'),
        text:
          error.code == 4001
            ? t('YourTransactionWasCanceled')
            : error.code == "-32603"
            ? t("YourTimeHasnComeYet")
            :  t('SomethingHappenedOne'),
        confirmButtonColor: "#ecc06f",
        confirmButtonText:  t('Accept'),
        footer:
          "<span>Asegurate de estar conectado a la red correcta, (POLYGON)</span>",
      });
      setIspending(false);
      setIsMinting(false);
    }
  };

  const reservedMint = async (tokenId) => {
    //si no hay cartera conectada concetar cartera
    !wallet && (await getUserWallet());
    const mintPrice = 0; //price * num;
    tokenId > 1000 && tokenId <= 4000 ? (mintPrice = 14) : (mintPrice = 25);

    try {
      const { ethereum } = window;
      let chainId = await ethereum.request({ method: "eth_chainId" });
      setChain(chainId);

      while (chainId !== CONFIG.NETWORK.ID) {
        //await addPolygonNetwork();
      }

      if (ethereum) {
        const provider = new ethers.providers.Web3Provider(ethereum);
        const signer = provider.getSigner();
        const connectedContract = new ethers.Contract(
          CONFIG.CONTRACT_ADDRESS,
          contract.output.abi,
          signer
        );

        let nftTxn = await connectedContract.reservedMint(tokenId, {
          value: ethers.utils.parseEther(mintPrice.toString()),
        });
        setIsMinting(true);
        console.log("Mining...please wait.");
        await nftTxn.wait();
        console.log("nfts minted");
        setIsMinting(false);
        getCurrentSupply();
        setMinted(true);

        setTxn(`https://polygonscan.com/tx/${nftTxn.hash}`);

        const receipt = await provider.getTransactionReceipt(nftTxn.hash);
        const isRevealed = await connectedContract.revealed();
        const tokensmintedintxn = await decodeTxnLogs(receipt);
        await getnft(tokensmintedintxn, isRevealed);
      } else {
      }
    } catch (error) {
      //añadir mensaje de error
      MySwal.fire({
        icon: "error",
        title:
          error.code == 4001
            ? t('TransactionCanceled')
            : t('WeHaveProblem'),
        text:
          error.code == 4001
            ? "Tu Transacción fue cancelada."
            : t('SomethingHappenedOne'),
        confirmButtonColor: "#ecc06f",
        confirmButtonText:  t('Accept'),
        footer:
          "<span>Asegúrate de estar conectado a la red correcta, (POLYGON)</span>",
      });
      setIspending(false);
      setIsMinting(false);
    }
  };

  const getCurrentSupply = async () => {
    const { ethereum } = window;

    try {
      const provider = new ethers.providers.Web3Provider(ethereum);
      const signer = provider.getSigner();
      const connectedContract = new ethers.Contract(
        CONFIG.CONTRACT_ADDRESS,
        contract.output.abi,
        signer
      );

      const txn = await connectedContract.totalSupply();
      const totalSupply = parseInt(txn._hex, 16);
      setCurrentSupply(totalSupply);

      return totalSupply;
    } catch (error) {
      console.log(error);
    }
  };

  const decodeTxnLogs = async (txnlogs) => {
    const events = txnlogs.logs;

    let tokenIds = [];

    events.forEach((event) => {
      const tokenId = parseInt(event.topics[3], 16);

      if (tokenId.toString().length <= 5) tokenIds.push(tokenId);
    });

    console.log("tokenIds", tokenIds);
    setTokensMinted(tokenIds);
    console.log(tokensMinted);
    return tokenIds;
  };

  const getTokenUri = async (tokenId) => {
    const { ethereum } = window;

    try {
      const provider = new ethers.providers.Web3Provider(ethereum);
      const signer = provider.getSigner();
      const connectedContract = new ethers.Contract(
        CONFIG.CONTRACT_ADDRESS,
        contract.output.abi,
        signer
      );

      const txn = await connectedContract.tokenURI(tokenId);
      console.log(txn);
      return txn;
    } catch (error) {
      console.log(error);
    }
  };

  function changeLanguage(params) {
    i18n.changeLanguage(params);
  }




  const getnft = async (tokens, revealed) => {
    let nftsMinted = [];
    console.log("tokens", tokens);
    console.log(revealed);
    try {
      if (!revealed) {
        // como los nfts no no estan revelados, llamar directamente a hidden.json
        // y mostrar en el boton el account del user ( ya esta hecho )
        // una vez hecho activar cambio de red y contract address.
        const fetchNftsdata = async () => {
          return new Promise((resolve, reject) => {
            tokens.forEach(async (element) => {
              const res = await fetch(
                "https://apinft.racksmafia.com/api/hidden.json"
              );
              const json = await res.json();
              nftsMinted.push(json);
              if (nftsMinted.length === tokens.length) resolve();
            });
          });
        };
        await fetchNftsdata();
        setNfts(nftsMinted);
        setShowNftComponent(true);
      } else {
        console.log("tokens", tokens);
        const res = await axios.post("https://apinft.racksmafia.com/api/", {
          nfts: tokens,
        });
        console.log(res);
        setNfts(res.data);
        setShowNftComponent(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const setCurrentPrice = () => {
    currentSupply > 1000 && currentSupply <= 4000 && setPrice(50);
    currentSupply > 4000 && setPrice(50);
  };

  const ethereum = window?.ethereum;

  ethereum?.on("chainChanged", (chainId) => {
    setChain(chainId);
  });

  ethereum?.on("accountsChanged", (account) => {
    setWallet(account);
  });

  useEffect(() => {
    if (window.ethereum) {
      const provider = new ethers.providers.Web3Provider(ethereum);
      const signer = provider.getSigner();
      const connectedContract = new ethers.Contract(
        CONFIG.CONTRACT_ADDRESS,
        contract.output.abi,
        signer
      );
      connectedContract.on("Transfer", () => getCurrentSupply());
    }

    getCurrentSupply();
    setCurrentPrice();
    userIswhitelisted();
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, [wallet, chain, currentSupply]);

  return (
    <div className="App">
      <Loading />
      {/*<Login />*/}
      <Header   getUserWallet={getUserWallet} wallet={wallet} />
      <Banner />
      <MintSection
        MintNFT={MintNFT}
        price={price}
        setPrice={setPrice}
        showNftComponent={showNftComponent}
        nfts={nfts}
        minting={minting}
        txn={txn}
        wallet={wallet}
        currentSupply={currentSupply}
        userIswhitelisted={userIswhitelisted}
        userw={userw}
        whitelistOn={whitelistOn}
      />
      <Carrousel />
      <ConfigNft />
      <Exclusives />
      <Museum />
      <Team />
      <Colabs />
      <Accordion />
      <Footer changeLanguage={changeLanguage} />
    </div>
  );
}

export default App;
